<template>
  <FormContainer>
    <template #title>Situation apprenti(e)</template>
    <template #content>
      <div class="form__bloc">
        <WrapperDropdown
          id="field_40"
          v-model="situationAvantContratModel"
          label="Situation avant contrat"
          :required="meta.apprenti?.situationAvantContrat?.$status === PropertyStatus.Required"
          :alertLabel="meta.apprenti?.situationAvantContrat?.$messageErreurDirty!"
          class="col-18 col-md-18 col-sm-36"
          :items="lov.SituationAvantContrat"
          :readonly
          key-id="code"
          key-label="intitule"
        />
        <WrapperDropdown
          id="field_41"
          v-model="dernierDiplomePrepareModel"
          label="Dernier diplôme ou titre préparé"
          :required="meta.apprenti?.dernierDiplomeOuTitrePrepare?.$status === PropertyStatus.Required"
          :alertLabel="meta.apprenti?.dernierDiplomeOuTitrePrepare?.$messageErreurDirty!"
          class="col-18 col-md-18 col-sm-36"
          :items="lov.Diplome"
          :readonly
          key-id="code"
          key-label="intitule"
        />
      </div>

      <div class="form__bloc">
        <WrapperDropdown
          id="field_42"
          v-model="derniereAnneeModel"
          label="Dernière classe / année suivie"
          :required="meta.apprenti?.derniereAnneeApprenti?.$status === PropertyStatus.Required"
          :alertLabel="meta.apprenti?.derniereAnneeApprenti?.$messageErreurDirty!"
          class="col-36"
          :items="lov.DerniereAnneeApprenti"
          :readonly
          key-id="code"
          key-label="intitule"
        />
      </div>
      <div class="form__bloc">
        <WrapperInput
          id="field_43"
          v-model="intituleDernierDiplomeModel"
          label="Intitulé précis du dernier diplôme ou titre préparé"
          class="col-18 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_DIPLOME_PREPARE"
          :required="meta.apprenti?.intituleDernierDiplomeOuTitrePrepare?.$status === PropertyStatus.Required"
          :alertLabel="meta.apprenti?.intituleDernierDiplomeOuTitrePrepare?.$messageErreurDirty!"
          :maxlength="250"
          :readonly
          deletable
        />
        <WrapperDropdown
          id="field_44"
          v-model="diplomePlusEleveModel"
          label="Diplôme ou titre le plus élevé obtenu"
          :required="meta.apprenti?.diplomeOuTitreLePlusEleveObtenu?.$status === PropertyStatus.Required"
          :alertLabel="meta.apprenti?.diplomeOuTitreLePlusEleveObtenu?.$messageErreurDirty!"
          class="col-18 col-md-18 col-sm-36"
          :items="lov.Diplome"
          :readonly
          key-id="code"
          key-label="intitule"
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { useDemandeCAPPStore } from '@/features/interface/demande/capp/useDemandeCAPPStore'
  import { FormContainer, PLACEHOLDER_DIPLOME_PREPARE } from '@/features/interface/demande/shared'
  import { storeToRefs } from 'pinia'
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'

  const store = useDemandeCAPPStore()
  const { setupFieldWithKey } = store
  const { meta, lov, readonly } = storeToRefs(store)

  const intituleDernierDiplomeModel = setupFieldWithKey<string>('apprenti.intituleDernierDiplomeOuTitrePrepare', true)
  const situationAvantContratModel = setupFieldWithKey<string>('apprenti.situationAvantContrat', false)
  const dernierDiplomePrepareModel = setupFieldWithKey<string>('apprenti.dernierDiplomeOuTitrePrepare', false)
  const derniereAnneeModel = setupFieldWithKey<string>('apprenti.derniereAnneeApprenti', false)
  const diplomePlusEleveModel = setupFieldWithKey<string>('apprenti.diplomeOuTitreLePlusEleveObtenu', false)
</script>
